export const NAME = 'configs';

const CONTEXT = 'CONFIGS';

const HELLO_WORLD = `${CONTEXT}::HELLO_WORLD`;

export const ACTION_TYPES = {
  HELLO_WORLD,
};
